/*@flow*/
import type { Node } from 'react';
import React, { Fragment } from 'react';
import GlobalModal from 'comps/GlobalModal';
import Toaster from 'comps/Toaster';
import useQueryTracker from 'comps/useQueryTracker';

// Global event listeners
$(document).on('turbolinks:load', () => {
  if (window.ga) {
    // Send Google Analytics pageview data
    window.ga('send', 'pageview', { page: window.location.pathname });
  }
});

export default (): Node => {
  useQueryTracker();

  return (
    <Fragment>
      <GlobalModal />
      <Toaster />
    </Fragment>
  );
};
